import _ from 'lodash';
// @mui
import Box from '@mui/material/Box';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
//reducers
import { selectTranslations } from 'state/reducers/translation.reducers';
import { useAppSelector } from 'hooks/redux.hooks';

interface IStepping {
	prefix: string;
	steps: number;
	activeStep: number;
}

export default function Stepping(props: IStepping) {
	const { prefix, steps, activeStep } = props;
	const t = useAppSelector(selectTranslations);

	const stepsArr = Array.from({ length: steps }, (_, index) => index + 1);

	return (
		<Box sx={{ width: '100%' }}>
			<Stepper activeStep={activeStep - 1} alternativeLabel>
				{stepsArr.map((num) => {
					return (
						<Step key={num}>
							<StepLabel>{t(`${prefix}${num}.text`)}</StepLabel>
						</Step>
					);
				})}
			</Stepper>
		</Box>
	);
}
